import React from 'react';
import { useFormContext, useWatch } from 'react-hook-form';

import { Icon, iconNames } from 'shared_DEPRECATED/components/Icon';

import { CHAT_FORM_FIELD_NAMES } from 'features/chat/config';
import { ChatFormValues } from 'features/chat/config/types/ChatForm';
import { useChatMessageSchedulingContext } from 'features/chat/context/chatMessageScheduling';

import { ScheduleIcon } from '../../ChatMessagesScheduling/ScheduleIcon';
import { ChatFormTextInput } from '../ChatFormTextInput';
import { ChatFormRecordAudioButton } from './RecordAudioButton';
import { ChatFormSubmitButton } from './SubmitButton';

type ChatFormTextModeProps = {
  handleKeyDown: (e: React.KeyboardEvent<HTMLTextAreaElement>) => void;
  startRecording: () => void;
  disabled: boolean;
  isEditing: boolean;
  children?: React.ReactNode;
};

export const ChatFormTextMode = ({
  handleKeyDown,
  startRecording,
  disabled,
  isEditing,
  children,
}: ChatFormTextModeProps) => {
  const methods = useFormContext<ChatFormValues>();

  const messageText = useWatch({
    control: methods.control,
    name: CHAT_FORM_FIELD_NAMES.TEXT,
  });

  const { isScheduledListVisible: isSchedulingMode } =
    useChatMessageSchedulingContext();

  return (
    <>
      <ChatFormTextInput handleKeyDown={handleKeyDown}>
        {children}
      </ChatFormTextInput>
      {messageText ? (
        <ChatFormSubmitButton disabled={disabled}>
          {isSchedulingMode && !isEditing ? (
            <ScheduleIcon iconColor="var(--fgPrimaryInverse)" size="24px" />
          ) : (
            <Icon
              name={iconNames.paperPlane}
              height="18px"
              width="18px"
              stroke="var(--fgPrimaryInverse)"
            />
          )}
        </ChatFormSubmitButton>
      ) : (
        <ChatFormRecordAudioButton
          disabled={disabled}
          onClick={startRecording}
        />
      )}
    </>
  );
};
